import { hasClass } from '@common/Utils';
import axios from 'axios';
import { useCallback, useState } from 'react';

export default function useShare() {
    const [loading, setLoading] = useState(false);

    const startShare = useCallback(async ({ _apiPath, _title, _callback }: { _apiPath: string; _title: string; _callback: () => void }) => {
        try {
            setLoading(true);
            const res: { data: { shortened: string } } = await axios({
                method: 'POST',
                url: _apiPath,
                data: { url: location.href },
            });

            const isMobile: boolean = hasClass(document.body, 'mobile');

            if (isMobile) {
                await shareUrl(res.data.shortened, _title);
            } else {
                await copyUrl(res.data.shortened);
                _callback();
            }
        } catch (err) {
            //
        } finally {
            setLoading(false);
        }
    }, []);

    const copyUrl = async (_surl: string) => {
        try {
            await navigator.clipboard.writeText(_surl);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };

    const shareUrl = async (_surl: string, _title: string) => {
        try {
            await navigator.share({ title: _title, url: _surl });
        } catch (err) {
            console.error('Failed to shareUrl: ', err);
        }
    };

    return { startShare, loading };
}
